<template>
  <div :class="['goods_item-wrap', size == 'large' ? 'large' : 'small', collapsed ? '' : 'view-packge']">
    <!-- 基本信息 -->
    <div class="item-base">
      <div class="item-image">
        <img v-if="base.pic" :src="base.pc_pic || base.pic" :alt="base.name" />
      </div>
      <div class="item-intro">
        <div class="item-info">
          <div class="item-info-l">
            <router-link :to="`/detail?id=${base.unique_id || base.spu}`">
              <div class="item-name">{{base.name}}</div>
            </router-link>
            <div class="item-desc">
              <!-- <div class="item-desc_info">{{base.short_desc}}</div> -->
              <div class="item-desc_info"></div>
              <div class="item-money__large">
                <div class="item-count__large">x {{base.qty<1? 0 : base.qty}}</div>
                <div class="item-price__large">￥{{base.original_price | toFixed(2)}}</div>
              </div>
            </div>
          </div>
          <div class="item-info-r">
            <div class="item-price">￥{{base.original_price | toFixed(2)}}</div>
          </div>
        </div>
        <div class="item-skus-or-package">
          <!-- 套装且有数据 -->
          <template v-if="/collection/i.test(base.display_type) && base.collections && base.collections.length">
            <div class="item-package" @click="toggle">
              <span>套装详情</span>
              <i class="iconfont">&#xe678;</i>
            </div>
          </template>
          <!-- 单品且有规格 -->
          <template v-else-if="/(capacity|color)/i.test(base.display_type) && base.spec_desc">
            <div class="sku-skus-info">
              {{base.display_type | classify }}：
              <span v-if="base.display_type == 'color' && base.spec_property" class="color-dot" :style="{background: `#${base.spec_property}`}"></span>
              {{base.spec_desc}}
            </div>
          </template>
          <template v-else>
            <div class="warning"></div>
          </template>
          <div class="item-count">x {{base.qty < 1? 0 : base.qty}}</div>
        </div>
      </div>
    </div>
    <!-- 套装信息 -->
    <div v-if="Array.isArray(base.collections) && base.collections.length" :class="['item-extra', gifts && gifts.length ? 'btm-border' : '']">
      <div class="package-items">
        <div v-for="(item, index) in base.collections" :key="index" class="package-item item-base">
          <div class="item-image">
            <img v-if="item.pc_pic || item.pic" :src="item.pc_pic || item.pic" :alt="item.name" />
          </div>
          <div class="item-intro">
            <div class="item-name">{{item.name}}</div>
            <div class="item-skus-or-package">
              <div v-if="item.sku" class="sku-skus-info">
                {{item.display_type | classify }}：
                <span v-if="item.display_type == 'color' && item.spec_property" class="color-dot" :style="{background: `#${item.spec_property}`}"></span>
                {{item.spec_desc}}
              </div>
              <div v-else class="sku-skus-info"></div>
              <div class="item-count">x {{item.qty<1 ? 0 : item.qty}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 赠品信息 -->
    <div v-if="Array.isArray(gifts) && gifts.length" class="item-gift item-extra-clone">
      <div class="gift-hits">{{giftName || '赠品'}}</div>
      <div class="gift-items">
        <div v-for="(item, index) in gifts" :key="index" class="gift-item item-base">
          <div class="item-image">
            <img v-if="item.pic" :src="item.pic" :alt="item.name" />
          </div>
          <div class="item-intro">
            <div class="item-info">
              <div class="item-name">{{item.name}}</div>
              <div class="item-count">x {{item.qty<1? 0 : item.qty}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "GoodsItem",
  props: {
    base: {
      type: Object,
      required: true
    },
    gifts: {
      type: Array,
      required: false
    },
    giftName: {
      type: String,
      required: false
    },
    size: {
      type: String,
      default: "small",
      validator(value) {
        return ["small", "large"].indexOf(value) != -1;
      }
    }
  },
  data() {
    return {
      collapsed: true
    };
  },
  created() {
    this.initSource();
  },
  methods: {
    initSource() {
      if (typeof this.base.collections == "string" && this.base.collections.length) {
        let items = null;
        try {
          items = JSON.parse(this.base.collections);
        } catch(err) {
          console.warn(err);
        }
        items && this.$set(this.base, 'collections', items);
      }
    },
    toggle() {
      this.collapsed = !this.collapsed;
    }
  }
}
</script>

<style lang="scss" scoped>
  .goods_item-wrap {
    width: 100%; margin-bottom: 30px; display: flex; flex-direction: column; justify-content: flex-start; align-items: flex-start; font-size: 12px; color: #000;
    &:last-child { margin-bottom: 0; }
    .item-base {
      width: 100%; display: flex; justify-content: flex-start; align-items: flex-start; // margin-bottom: 60rpx;
      &:last-child { margin-bottom: 0; }
      .item-image {
        width: 60px; min-width: 60px; height: 80px; display: flex; justify-content: center; align-items: center;
        img { width: 100%; height: auto; }
      }
      .item-intro {
        margin-left: 20px; width: calc(100% - 80px); height: 80px; padding: 0.625rem 0;
        display: flex; flex-direction: column; justify-content: space-between;
        .item-info {
          width: 100%; display: flex; justify-content: space-between;
          .item-info-l {
            width: calc(100% - 70px);
            // width: 175px; // white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
            a { text-decoration: none; }
            a:hover { text-decoration: underline; }
            .item-name { font-weight: 700; white-space: normal; display: -webkit-box; -webkit-box-orient: vertical; -webkit-line-clamp: 2; overflow: hidden; }
            .item-desc {
              color: #575757; margin-top: 4px; display: flex; justify-content: flex-start; align-items: center;
              .item-desc_info {
                max-width: 100%; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
              }
              .item-money__large {
                display: none; justify-content: space-between; align-items: center; flex: 1;
              }
            }
          }
          .item-info-r {
            width: 70px;
            .item-price {
              font-size: 12px; color: #575757; text-align: right;
            }
          }
        }
        .item-skus-or-package {
          display: flex; justify-content: space-between; align-items: center;
          .sku-skus-info {
            font-size: 12px; color: #999999; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
            .color-dot { display: inline-block; width: 0.625rem; height: 0.625rem; border-radius: 50%; background: #999999; }
          }
          .item-package {
            display: flex; justify-content: flex-start; align-items: center; line-height: 20px; cursor: pointer;
            .iconfont { margin-left: 10px; color: #CACACA; transition: transform 0.1s ease-in; }
          }
          .item-count { font-size: 12px; color: #999999; min-width: 2rem; text-align: right; }
        }
      }
    }
    .item-extra, .item-extra-clone {
      padding-left: 80px; width: 100%; transition: height 0.1s ease-in;
      .package-items {
        width: 100%; 
        .package-item {
          margin-top: 30px;
          &:first-child { margin-top: 0; }
          .item-intro {
            justify-content: center; padding: 0;
            .item-name { white-space: normal; display: -webkit-box; -webkit-box-orient: vertical; -webkit-line-clamp: 2; overflow: hidden; }
            .item-skus-or-package { margin-top: 14px; }
          }
        }
      }
      &.btm-border {
        .package-items { padding-bottom: 30px; border-bottom: 1px solid #CFD0D1; }
      }
    }
    .item-extra { height: 0; overflow: hidden; }
    .item-gift {
      margin-top: 30px;
      .gift-hits { margin-bottom: 20px; }
      .gift-items {
        .gift-item {
          margin-top: 30px;
          &:first-child { margin-top: 0; }
          .item-intro {
            justify-content: center;
            .item-info {
              flex-direction: column;
              .item-name { white-space: normal; display: -webkit-box; -webkit-box-orient: vertical; -webkit-line-clamp: 2; overflow: hidden; }
              .item-count { min-width: 2rem; font-size: 12px; color: #999; }
            }
          }
        }
      }
    }
    // .item-base + .item-gift { margin-top: 0; }
    &.view-packge {
      .item-base {
        .item-intro {
          .item-package {
            .iconfont { transform: rotate(180deg); }
          }
        }
      }
      .item-extra {
        margin-top: 30px; height: auto;
        & + .item-gift { margin-top: 30px; }
      }
    }
  }

  @media screen and (min-width: 48em) {
    .goods_item-wrap:not(.small) {
      .item-gift {
        .gift-items {
          .gift-item {
            .item-intro {
              .item-info {
                flex-direction: row;
                .item-count { text-align: right; }
              }
            }
          }
        }
      }
    }
  }

  @media screen and (min-width: 64em) {
    .goods_item-wrap:not(.small) {
      .item-base {
        .item-image { width: 80px; min-width: 80px; height: 106px; }
        .item-intro {
          margin-left: 15px; width: calc(100% - 95px); height: 106px;
        }
      }
      &.large {
        .item-base {
          .item-intro {
            .item-info {
              .item-info-l {
                width: 100%;
                .item-desc {
                  .item-desc_info { width: 400px; }
                  .item-money__large { display: flex; }
                }
              }
              .item-info-r { display: none; }
            }
            .item-skus-or-package {
              .item-count { display: none; }
            }
          }
        }
        .item-extra {
          .package-items {
            .package-item {
              .item-intro {
                .item-skus-or-package {
                  justify-content: flex-start;
                  .sku-skus-info { width: 320px; }
                  .item-count { display: block; }
                }
              }
            }
          }
        }
        .item-gift {
          .gift-items {
            .gift-item {
              .item-intro {
                .item-info {
                  justify-content: flex-start;
                  .item-name { width: 305px; }
                  .item-count { display: block; }
                }
              }
            }
          }
        }
      }
    }
  }
</style>